import Api from '@/api/api'
import configApi from '@/api/config/_api_config'

const post = (suffix, data) => {
    const { access_token, ...payload } = data
    return Api().post('/consultations/tableau-sage-femme' + suffix, payload, {
        med_access_scoped: true, timeout: 20000,
        headers: { 'X-Sage-Femme-Access': access_token }
    }).then(response => response.data)
}

// Same read interface as the shared widgets, with a separate, personal capability.
export default {
    getActionsAccess: () => configApi().post('/sage-femme/actions-access', {}, { timeout: 20000 }).then(response => response.data),
    async actionRequest(method, suffix, payload) {
        const credential = await this.getActionsAccess()
        if (!credential.success || !credential.data || !credential.data.access_token) throw new Error('Accès indisponible.')
        const config = { med_access_scoped: true, timeout: 20000, headers: { 'X-Sage-Femme-Actions': credential.data.access_token } }
        const url = '/consultations/actions-sage-femme' + suffix
        const response = method === 'get' ? await Api().get(url, config) : await Api().post(url, payload, config)
        return response.data
    },
    getAvisMedicalConsultation(id) { return this.actionRequest('get', '/' + id + '/avis') },
    demanderAvisMedical(id, data) { return this.actionRequest('post', '/' + id + '/avis', data) },
    donnerRendezVousConsultation(data) { return this.actionRequest('post', '/rendez-vous', data) },
    disponibilite: () => configApi().get('/sage-femme/disponibilite', { timeout: 20000 }).then(response => response.data),
    getTableauMedecinAccess: () => configApi().post('/sage-femme/tableau-access', {}, { timeout: 20000 }).then(response => response.data),
    getClotureMedecinAccess: () => configApi().post('/sage-femme/cloture-access', {}, { timeout: 20000 }).then(response => response.data),
    cloturerConsultationMedecin: (id, payload, token) => Api().post('/consultations/' + id + '/cloture-sage-femme', payload, {
        med_access_scoped: true, timeout: 20000, headers: { 'X-Sage-Femme-Access': token }
    }).then(response => response.data),
    getReferenceCatalogue: ({ access_token }) => Api().get('/consultations/tableau-sage-femme/references/catalogue', {
        med_access_scoped: true, timeout: 20000, headers: { 'X-Sage-Femme-Access': access_token }
    }).then(response => response.data),
    getTableauMedecin: data => post('', data),
    getFiltresTableauMedecin: data => post('/filtres', data),
    getStatistiquesTableauMedecin: data => post('/statistiques', data),
    getRendezVousMedecin: data => post('/rendez-vous', data),
    ouvrirConsultationTableauMedecin: data => post('/ouvrir', data)
}
